module.exports = __webpack_public_path__ + "media/soundtrack.cc7f0fc2.mp3";